import { Behavior } from '../../behavior';
import { Injectable } from '@angular/core';
import { BehaviorContext } from '../../behavior-context';
import { HttpClient } from '@angular/common/http';
import {
  getFormattedContactInfo,
  OTP_CONTACT_ID,
  OTP_CONTACT_METHOD,
  OTP_SEND_CODE_ERROR,
} from './otp-util';

@Injectable()
export class OtpSendCode implements Behavior {
  constructor(public http: HttpClient) {}
  async execute(
    args: {
      sendCodeUrl: string;
      sendCodeEndpoint: string;
      contactIdFormControlName: string;
    },
    context: BehaviorContext
  ): Promise<any> {
    const contactIdControl = context.formGroup.get(
      args.contactIdFormControlName
    );
    const contactId = contactIdControl.value;
    const contactInfo = getFormattedContactInfo(contactId);
    const url = args.sendCodeUrl + args.sendCodeEndpoint;

    context.set(OTP_CONTACT_ID, contactInfo.contactId);
    context.set(OTP_CONTACT_METHOD, contactInfo.contactMethod);
    try {
      const result = await this.http
        .post(url, {
          authenticationMethod: contactInfo.contactMethod,
          authenticationId: contactInfo.contactId,
        })
        .toPromise();

      context.set(OTP_SEND_CODE_ERROR, false);
    } catch (error) {
      context.set(OTP_SEND_CODE_ERROR, error);
    } finally {
    }
  }
}
